import { EnumUtils } from '../../../utils/enum.utils';

export enum TagActionContext {
  Create = 'create',
  Edit = 'edit',
  Clone = 'clone',
}

export namespace TagActionContext {
  export function getAllContexts(): TagActionContext[] {
    return EnumUtils.GetValues<TagActionContext>(TagActionContext);
  }

  export function isValid(context: null | string): boolean {
    if (context === null) {
      return false;
    }

    return getAllContexts().includes(context as TagActionContext);
  }
}
